/**
 * @fileoverview gRPC-Web generated client stub for somewear.api.v1
 * @enhanceable
 * @public
 */
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0
// source: api/device.proto
/* eslint-disable */
// @ts-nocheck
import * as grpcWeb from 'grpc-web';
import * as device_proto_pb from '../device_proto_pb'; // proto import: "device_proto.proto"
import * as api_device_pb from '../api/device_pb'; // proto import: "api/device.proto"
export class DeviceClient {
    client_;
    hostname_;
    credentials_;
    options_;
    constructor(hostname, credentials, options) {
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    methodDescriptorGetDeviceEventStream = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/GetDeviceEventStream', grpcWeb.MethodType.SERVER_STREAMING, api_device_pb.DeviceEventStreamRequest, device_proto_pb.DeviceEventResponseList, (request) => {
        return request.serializeBinary();
    }, device_proto_pb.DeviceEventResponseList.deserializeBinary);
    getDeviceEventStream(request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/somewear.api.v1.Device/GetDeviceEventStream', request, metadata || {}, this.methodDescriptorGetDeviceEventStream);
    }
    methodDescriptorGetActiveDevice = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/GetActiveDevice', grpcWeb.MethodType.UNARY, api_device_pb.GetActiveDeviceRequest, device_proto_pb.DeviceDto, (request) => {
        return request.serializeBinary();
    }, device_proto_pb.DeviceDto.deserializeBinary);
    getActiveDevice(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/GetActiveDevice', request, metadata || {}, this.methodDescriptorGetActiveDevice, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/GetActiveDevice', request, metadata || {}, this.methodDescriptorGetActiveDevice);
    }
    methodDescriptorUnregisterDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/UnregisterDevices', grpcWeb.MethodType.UNARY, api_device_pb.UnregisterDeviceRequest, device_proto_pb.DeviceList, (request) => {
        return request.serializeBinary();
    }, device_proto_pb.DeviceList.deserializeBinary);
    unregisterDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/UnregisterDevices', request, metadata || {}, this.methodDescriptorUnregisterDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/UnregisterDevices', request, metadata || {}, this.methodDescriptorUnregisterDevices);
    }
    methodDescriptorGetDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/GetDevices', grpcWeb.MethodType.UNARY, api_device_pb.GetIdentityDevicesRequest, api_device_pb.GetDevicesResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.GetDevicesResponse.deserializeBinary);
    getDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/GetDevices', request, metadata || {}, this.methodDescriptorGetDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/GetDevices', request, metadata || {}, this.methodDescriptorGetDevices);
    }
    methodDescriptorGetDevicesSummary = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/GetDevicesSummary', grpcWeb.MethodType.UNARY, api_device_pb.GetDevicesSummaryRequest, device_proto_pb.DeviceSummaryResponseList, (request) => {
        return request.serializeBinary();
    }, device_proto_pb.DeviceSummaryResponseList.deserializeBinary);
    getDevicesSummary(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/GetDevicesSummary', request, metadata || {}, this.methodDescriptorGetDevicesSummary, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/GetDevicesSummary', request, metadata || {}, this.methodDescriptorGetDevicesSummary);
    }
    methodDescriptorUpdateDevicesSettings = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/UpdateDevicesSettings', grpcWeb.MethodType.UNARY, device_proto_pb.DeviceSettingsRequestList, device_proto_pb.DeviceEventResponseList, (request) => {
        return request.serializeBinary();
    }, device_proto_pb.DeviceEventResponseList.deserializeBinary);
    updateDevicesSettings(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/UpdateDevicesSettings', request, metadata || {}, this.methodDescriptorUpdateDevicesSettings, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/UpdateDevicesSettings', request, metadata || {}, this.methodDescriptorUpdateDevicesSettings);
    }
    methodDescriptorAssignDevice = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/AssignDevice', grpcWeb.MethodType.UNARY, api_device_pb.AssignDeviceRequest, api_device_pb.AssignDeviceResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.AssignDeviceResponse.deserializeBinary);
    assignDevice(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/AssignDevice', request, metadata || {}, this.methodDescriptorAssignDevice, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/AssignDevice', request, metadata || {}, this.methodDescriptorAssignDevice);
    }
    methodDescriptorUnassignDevice = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/UnassignDevice', grpcWeb.MethodType.UNARY, api_device_pb.UnassignDeviceRequest, api_device_pb.UnassignDeviceResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.UnassignDeviceResponse.deserializeBinary);
    unassignDevice(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/UnassignDevice', request, metadata || {}, this.methodDescriptorUnassignDevice, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/UnassignDevice', request, metadata || {}, this.methodDescriptorUnassignDevice);
    }
    methodDescriptorBatchDisableDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/BatchDisableDevices', grpcWeb.MethodType.UNARY, api_device_pb.BatchDisableDevicesRequest, api_device_pb.BatchActivationChangeResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.BatchActivationChangeResponse.deserializeBinary);
    batchDisableDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/BatchDisableDevices', request, metadata || {}, this.methodDescriptorBatchDisableDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/BatchDisableDevices', request, metadata || {}, this.methodDescriptorBatchDisableDevices);
    }
    methodDescriptorBatchSuspendDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/BatchSuspendDevices', grpcWeb.MethodType.UNARY, api_device_pb.BatchSuspendDevicesRequest, api_device_pb.BatchActivationChangeResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.BatchActivationChangeResponse.deserializeBinary);
    batchSuspendDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/BatchSuspendDevices', request, metadata || {}, this.methodDescriptorBatchSuspendDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/BatchSuspendDevices', request, metadata || {}, this.methodDescriptorBatchSuspendDevices);
    }
    methodDescriptorBatchActivateDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/BatchActivateDevices', grpcWeb.MethodType.UNARY, api_device_pb.BatchActivateDevicesRequest, api_device_pb.BatchActivationChangeResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.BatchActivationChangeResponse.deserializeBinary);
    batchActivateDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/BatchActivateDevices', request, metadata || {}, this.methodDescriptorBatchActivateDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/BatchActivateDevices', request, metadata || {}, this.methodDescriptorBatchActivateDevices);
    }
    methodDescriptorCheckDevice = new grpcWeb.MethodDescriptor('/somewear.api.v1.Device/CheckDevice', grpcWeb.MethodType.UNARY, api_device_pb.CheckDeviceRequest, api_device_pb.CheckDeviceResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.CheckDeviceResponse.deserializeBinary);
    checkDevice(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Device/CheckDevice', request, metadata || {}, this.methodDescriptorCheckDevice, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Device/CheckDevice', request, metadata || {}, this.methodDescriptorCheckDevice);
    }
}
//# sourceMappingURL=DeviceServiceClientPb.js.map